import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { add_analytics_loading : true, add_analytics: '', add_analytics_error: false};

export function addAnalyticsOrgAdmin(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ADD_ANALYTICS_ORG_ADMIN:
        return {
            add_analytics_loading: true,
            add_analytics: '',
            add_analytics_error: false
        };
      case organisationConstants.RESPONSE_ADD_ANALYTICS_ORG_ADMIN:
        return {
            add_analytics_loading: false,
            add_analytics: action.add_analytics_org_admin,
            add_analytics_error: false
        };
      case organisationConstants.ERROR_ADD_ANALYTICS_ORG_ADMIN:
        return { 
            add_analytics_loading: false,
            add_analytics: '',
            add_analytics_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/addAnalyticsOrgAdmin.reducer.js